import { IOfferSpendPageLang } from '../../../types/lang'

export const offerSpendPageLang: IOfferSpendPageLang = {
	offer_spend_page: {
		btn_add_new: 'Add New_ru',
	}
}